import * as React from 'react';

import cn from 'classnames';
import SwipeableViews from 'react-swipeable-views';

import { BrandBlock } from '../BrandBlock';
import { BrandElementCard } from '../BrandElementCard';

import {
	IBrandBaseElementsScreenProps,
	IBrandBaseElementsScreenState,
} from './types';

import * as s from './BrandBaseElementsScreen.scss';

export class BrandBaseElementsScreen extends React.Component<IBrandBaseElementsScreenProps, IBrandBaseElementsScreenState> {

	state: IBrandBaseElementsScreenState = {
		currentSlideIndex: 0,
	};

	setCurrentSlideIndex(index: number) {
		this.setState({
			currentSlideIndex: index,
		});
	}

	onSlideIndexChange = (index: number) => {
		this.setCurrentSlideIndex(index);
	};

	onPageClick = (index: number) => () => {
		this.setCurrentSlideIndex(index);
	};

	render() {
		const {
			isMobile,
			downloadFileSize,
			downloadLinkUrl,
			downloadTitle,
			images = [],
			classNames: {
				block: blockClassName,
				content: contentClassName,
				card: cardClassName,
			} = {},
			onDownloadButtonClick,
		} = this.props;
		const {
			currentSlideIndex,
		} = this.state;

		return (
			<div className={cn(s.block, blockClassName)}>

				<BrandBlock
					title={''}
					downloadTitle={downloadTitle}
					downloadFileSize={downloadFileSize}
					downloadLinkUrl={downloadLinkUrl}
					classNames={{
						block: contentClassName,
						header: s.header,
					}}
					onDownloadButtonClick={onDownloadButtonClick}
				>
					{isMobile
						? <>
							<SwipeableViews
								index={currentSlideIndex}
								onChangeIndex={this.onSlideIndexChange}
							>
								{images.map((image, index) => (
									<BrandElementCard
										key={index}
										image={image}
										className={cardClassName}
									/>
								))}
							</SwipeableViews>

							<div className={s.pagination}>
								{images.map((page: string, index) => (
									<div
										key={index}
										className={cn(s.page, {
											[s.pageActive]: index === currentSlideIndex,
										})}
										onClick={this.onPageClick(index)}
									/>
								))}
							</div>
						</>
						: <div className={cn(s.content, contentClassName)}>
							{images.map((image, index) => (
								<BrandElementCard
									key={index}
									image={image}
									className={cardClassName}
								/>
							))}
						</div>
					}
				</BrandBlock>
			</div>
		);
	}

}
